import { render } from "./RequestModal.vue?vue&type=template&id=32775e8e&scoped=true"
import script from "./RequestModal.vue?vue&type=script&lang=js"
export * from "./RequestModal.vue?vue&type=script&lang=js"

import "./RequestModal.vue?vue&type=style&index=0&id=32775e8e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-32775e8e"

export default script